export enum AssesmentQuestionType {
	RADIO = 'RADIO',
	DROPDOWN = 'DROPDOWN',
	MULTI_DROPDOWN = 'MULTI_DROPDOWN',
	CHECKBOX = 'CHECKBOX'
}
